import axiosInstance from "@/api/config";
import { getErrorMessage } from "@/helpers/handleErrorResponse";
import {
  PoiBrandSearchPayload,
  PoiParameterResponse,
  PoiSearchPayload,
  PoiSearchResponse,
  PostPoiParametersPayload
} from "@/types/poiParameter";
import { CustomError } from "@/utils/errors";

export const getPoiParameters = async (
  country_id?: string
): Promise<PoiParameterResponse> => {
  try {
    const { data } = await axiosInstance.get(`/v1/datasets/poi-parameters`, {
      params: {
        country_id
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getBrandsSearch = async (
  payload: PoiBrandSearchPayload
): Promise<PoiSearchResponse> => {
  try {
    const { data } = await axiosInstance.get(`/v1/brands/search`, {
      params: {
        country_id: payload.countryId,
        category_code: payload.categoryCode,
        query: payload.query,
        page: payload.page ?? 1,
        per_page: payload.perPage ?? 10
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const postPoiParameters = async (payload: PostPoiParametersPayload) => {
  try {
    const { data } = await axiosInstance.post(
      `/v1/datasets/poi-parameters`,
      payload
    );
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};

export const getDatasetsSearch = async (
  payload: PoiSearchPayload
): Promise<PoiSearchResponse> => {
  try {
    const { data } = await axiosInstance.get(`/v1/datasets/search`, {
      params: {
        query: payload.query,
        page: payload.page ?? 1,
        per_page: payload.perPage ?? 10
      }
    });
    return data;
  } catch (error) {
    const { status, message } = getErrorMessage(error);
    const newError = new CustomError(message, status);
    throw newError;
  }
};
